import React, { Component } from 'react';
import '../../css/App.css';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = {

  pagetitlecard:{
    backgroundColor: "#DDD"
  },
  pagetitlecardheader:{
    padding: "10px"
  },
  pagetitle:{
    textAlign: "center",
    lineHeight: 2,
    fontFamily: 'Noto Sans TC, sans-serif'
  }
}

class CardPageTitle extends Component {
  render() {
    const { classes } = this.props;

    return ( 
        <Card
        className={classes.pagetitlecard}
        >
          <CardHeader
            title={<Typography className={classes.pagetitle}>{this.props.pageTitle1}<br/>{this.props.pageTitle2}</Typography>}           
            className={classes.pagetitlecardheader}
          />               
        </Card>   
    );
  }
}

export default withStyles(styles)(CardPageTitle);
